import React from 'react';
import { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useTheme } from 'styled-components';
import { StyledSkeleton } from './style';
import { StyledDiv } from '../../../Theme/CommonStyled';

const TableStyledSkeleton: React.FC = () => {
  const lines = new Array(10).fill(0).map((item, index) => index);
  return (
    <StyledDiv p={6}>
      {lines.map((item) => (
        <StyledDiv key={item} mt={10}>
          <StyledSkeleton height={16} />
        </StyledDiv>
      ))}
    </StyledDiv>
  );
};

const CardStyledSkeleton: React.FC = () => {
  const lines = new Array(4).fill(0).map((item, index) => index);
  return (
    <StyledDiv p={6}>
      <StyledSkeleton height={95} mb={8} />

      {lines.map((item) => (
        <StyledSkeleton key={item} height={40} mb={8} />
      ))}
    </StyledDiv>
  );
};

const BoxStyledSkeleton: React.FC = () => (
  <StyledDiv p={6}>
    <StyledDiv display="flex" mb={8}>
      <StyledDiv>
        <StyledSkeleton circle width={40} height={40} mr={8} />
      </StyledDiv>
      <StyledDiv width="100%" mt={4} mr={4}>
        <StyledSkeleton width="25%" height={12} />
        <StyledSkeleton width="60%" height={6} />
      </StyledDiv>
      <StyledDiv direction="rtl" width="100%" mt={4}>
        <StyledSkeleton width="25%" height={12} />
        <StyledSkeleton width="15%" height={6} />
      </StyledDiv>
    </StyledDiv>

    <StyledSkeleton height={148} />
    <StyledDiv display="flex" gap={8}>
      <StyledSkeleton width="50%" height={90} />
      <StyledSkeleton width="50%" height={90} />
    </StyledDiv>
  </StyledDiv>
);

const BrandStyledSkeleton: React.FC = () => (
  <StyledDiv p={6}>
    <StyledDiv display="flex" justifyContent="center" mb={8}>
      <StyledSkeleton circle width={60} height={60} mr={8} />
    </StyledDiv>

    <StyledSkeleton height={148} mb={8} />

    <StyledSkeleton height={30} mb={8} />
    <StyledSkeleton height={30} />
  </StyledDiv>
);

type SkeletonType = {
  type?: 'table' | 'card' | 'box' | 'brand';
};

const skeletonTypes = {
  table: <TableStyledSkeleton />,
  box: <BoxStyledSkeleton />,
  card: <CardStyledSkeleton />,
  brand: <BrandStyledSkeleton />
};
const Skeleton: React.FC<SkeletonType> = ({ type }) => {
  const theme = useTheme();
  return (
    <SkeletonTheme
      baseColor={theme.colors.displayBg}
      highlightColor={theme.colors.secondaryBackground}>
      {skeletonTypes[type || 'table']}
    </SkeletonTheme>
  );
};

export default Skeleton;
